const offers = state => state.offers;
const booking = state => state.booking;
const partQualityTypes = state => state.partQualityTypes;
const guilds = state => state.guilds;
const statuses = state => state.statuses;
const regionSignature = state => state.regionSignature;
const offersearch = state => state.offersearch;
const selectedOffer = state => state.selectedOffer;
const services = state => state.services;
const additionalServices = state => state.additionalServices;

export default {
  services,
  booking,
  offers,
  partQualityTypes,
  guilds,
  statuses,
  regionSignature,
  offersearch,
  selectedOffer,
  additionalServices
};
